"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Year = void 0;

var tslib_1 = require("tslib");

var date_fns_1 = require("date-fns");

var react_1 = tslib_1.__importDefault(require("react"));

var cell_1 = require("../styled/cell");

var Year = function Year(_a) {
  var selectedDate = _a.selectedDate,
      date = _a.date,
      onSelect = _a.onSelect;

  var handleClick = function handleClick() {
    return onSelect(date);
  };

  var isSelected = (0, date_fns_1.isSameYear)(selectedDate, date);
  return react_1.default.createElement(cell_1.Cell, {
    onClick: handleClick,
    isSelected: isSelected,
    "aria-selected": isSelected
  }, (0, date_fns_1.format)(date, 'yyyy'));
};

exports.Year = Year;